import React from "react";
import { Link } from 'react-router-dom';
import Header from '../common/header/Header';
import SEO from '../common/SEO';

const Aboutbh2 = () => {
    return (
        <>
            <SEO title="ConsultUs - East Coast Coders LLC" />
            <main className="main-wrapper">
                <Header />

                {/* Main Content */}
                <div style={{ padding: '2rem 0', marginTop: '80px' }}>
                    <div className="container">

                        {/* Hero Section */}
                        <div className="text-center mb-5">
                            <h1 style={{ fontSize: '2.5rem', fontWeight: 'bold', color: '#000' }}>
                                We're here to
                            </h1>
                            <h2 style={{ fontSize: '2.5rem', fontWeight: 'bold', color: '#00A8FF' }}>
                                guarantee your success
                            </h2>
                        </div>

                        {/* Consulting Services Box */}
                        <div className="mb-5">
                            <div style={{
                                backgroundColor: '#00A8FF',
                                color: 'white',
                                padding: '2rem',
                                borderRadius: '12px'
                            }}>
                                <p style={{ fontSize: '1rem', lineHeight: '1.6' }}>
                                    ConsultUs provides consulting services that help business owners
                                    achieve their dreams. We're committed to providing value and being a
                                    partner to build a professional, modern site that follows the
                                    StoryBrand Framework to clearly communicate the value it adds
                                    to potential clients.
                                </p>
                            </div>
                        </div>

                        {/* We're Here For You */}
                        <div className="text-center mb-5">
                            <h3 style={{ fontSize: '2rem', fontWeight: 'bold', color: '#000' }}>
                                We're here for you
                            </h3>
                            <h4 style={{ fontSize: '2rem', fontWeight: 'bold', color: '#00A8FF' }}>
                                no matter where you are
                            </h4>
                        </div>

                        {/* Our Mission */}
                        <div className="mb-5">
                            <h3 style={{ fontSize: '2rem', fontWeight: 'bold', marginBottom: '1.5rem' }}>
                                Our <span style={{ color: '#00A8FF' }}>Mission</span>
                            </h3>
                            <div className="row mb-3">
                                <div className="col-md-3"><strong>Unmatched Service</strong></div>
                                <div className="col-md-9">
                                    Support experts clients and financial investors with high growth strategy and
                                    streamlined governance.
                                </div>
                            </div>
                            <div className="row mb-3">
                                <div className="col-md-3"><strong>Results</strong></div>
                                <div className="col-md-9">
                                    Our team is flexible in its approach to support your company's objectives.
                                </div>
                            </div>
                            <div className="row mb-3">
                                <div className="col-md-3"><strong>Experience</strong></div>
                                <div className="col-md-9">
                                    We have worked with a wide spectrum of clients in various industries.
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-3"><strong>Technology</strong></div>
                                <div className="col-md-9">
                                    Using established yet cutting-edge technology—including AI and machine learning—to support business growth.
                                </div>
                            </div>
                        </div>

                        {/* Our Commitment */}
                        <div className="mb-5">
                            <h3 style={{ fontSize: '2rem', fontWeight: 'bold', marginBottom: '1.5rem' }}>
                                Our <span style={{ color: '#00A8FF' }}>Commitment</span>
                            </h3>
                            <div className="row mb-3">
                                <div className="col-md-3"><strong>Ethics</strong></div>
                                <div className="col-md-9">
                                    Ethics for ConsultUs means supporting our customers from confidentiality and
                                    security all of the works they requested.
                                </div>
                            </div>
                            <div className="row mb-3">
                                <div className="col-md-3"><strong>Quality</strong></div>
                                <div className="col-md-9">
                                    ConsultUs is committed to ensuring that our services and business practices are
                                    based on strong quality principles.
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-3"><strong>Community</strong></div>
                                <div className="col-md-9">
                                    We believe supporting the community through volunteering is important.
                                </div>
                            </div>
                        </div>

                        {/* Our Success Team */}
                        <div className="mb-5">
                            <h3 style={{ fontSize: '2rem', fontWeight: 'bold', marginBottom: '1.5rem', textAlign: 'center' }}>
                                Our <span style={{ color: '#00A8FF' }}>Success Team</span>
                            </h3>
                            <div className="row text-center">
                                <div className="col-md-4 mb-4">
                                    <div style={{
                                        width: '150px',
                                        height: '150px',
                                        backgroundColor: '#E0E0E0',
                                        borderRadius: '12px',
                                        margin: '0 auto 1rem'
                                    }}></div>
                                    <strong>Jenny Wilson</strong>
                                </div>
                                <div className="col-md-4 mb-4">
                                    <div style={{
                                        width: '150px',
                                        height: '150px',
                                        backgroundColor: '#E0E0E0',
                                        borderRadius: '12px',
                                        margin: '0 auto 1rem'
                                    }}></div>
                                    <strong>Eleanor Pena</strong>
                                </div>
                                <div className="col-md-4 mb-4">
                                    <div style={{
                                        width: '150px',
                                        height: '150px',
                                        backgroundColor: '#E0E0E0',
                                        borderRadius: '12px',
                                        margin: '0 auto 1rem'
                                    }}></div>
                                    <strong>Robert Fox</strong>
                                </div>
                            </div>
                        </div>

                        {/* Get in Touch */}
                        <div className="text-center mb-5">
                            <h3 style={{ fontSize: '2rem', fontWeight: 'bold', color: '#00A8FF', marginBottom: '1rem' }}>
                                Get in touch
                            </h3>
                            <p style={{ marginBottom: '2rem' }}>
                                Reach out to our team if you have any questions or inquiries
                            </p>
                            <div style={{ maxWidth: '600px', margin: '0 auto' }}>
                                <input
                                    type="text"
                                    placeholder="Name"
                                    className="form-control mb-3"
                                    style={{ padding: '12px' }}
                                />
                                <input
                                    type="email"
                                    placeholder="Email Address"
                                    className="form-control mb-3"
                                    style={{ padding: '12px' }}
                                />
                                <textarea
                                    placeholder="Message"
                                    className="form-control mb-3"
                                    rows="4"
                                    style={{ padding: '12px' }}
                                ></textarea>
                                <button
                                    className="btn btn-primary"
                                    style={{
                                        backgroundColor: '#00A8FF',
                                        border: 'none',
                                        padding: '12px 40px',
                                        fontSize: '1rem',
                                        width: '100%'
                                    }}
                                >
                                    Submit
                                </button>
                            </div>
                        </div>

                        {/* Footer Contact Details */}
                        <div style={{
                            backgroundColor: '#00A8FF',
                            color: 'white',
                            padding: '2rem',
                            borderRadius: '12px',
                            marginBottom: '2rem'
                        }}>
                            <div className="row">
                                <div className="col-md-4">
                                    <h5>Our Contact Details</h5>
                                    <p>Feel Free to Contact</p>
                                </div>
                                <div className="col-md-4">
                                    <strong>Web Page</strong>
                                    <p>www.Company.com</p>
                                    <strong>Email</strong>
                                    <p>Info@YourCompany.com</p>
                                </div>
                                <div className="col-md-4">
                                    <strong>OFFICE</strong>
                                    <p>123 Anywhere St.,<br/>Any City, State, Country 12345</p>
                                    <strong>Phone</strong>
                                    <p>123-456-7890</p>
                                </div>
                            </div>
                        </div>

                        {/* Back to Home Button */}
                        <div className="text-center">
                            <Link
                                to="/"
                                className="axil-btn btn-fill-primary"
                                style={{
                                    padding: '15px 30px',
                                    fontSize: '1.1rem',
                                    textDecoration: 'none',
                                    display: 'inline-block'
                                }}
                            >
                                Back to Home
                            </Link>
                        </div>

                    </div>
                </div>

            </main>
        </>
    );
};

export default Aboutbh2;
